'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00246 from "./presto.-Register-Page-View$$anon$6.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024 from "./presto.types$-Morbid-User-Details$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$5() {
  this.bvq = null;
  this.bvi = null;
  this.bvj = false;
  this.bvr = null;
  this.bvs = false;
  this.bvv = null;
  this.bvo = null;
  this.bvp = false;
  this.bvk = null;
  this.bvl = false;
  this.bvm = null;
  this.bvn = false;
  this.bvt = false;
  this.bvu = false;
  this.bvq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bvv = "MorbidUserDetails";
}
export { $c_Lpresto_RegisterPageView$$anon$5 as $c_Lpresto_RegisterPageView$$anon$5 };
$p = $c_Lpresto_RegisterPageView$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$5;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$5() {
}
export { $h_Lpresto_RegisterPageView$$anon$5 as $h_Lpresto_RegisterPageView$$anon$5 };
$h_Lpresto_RegisterPageView$$anon$5.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bvq;
});
$p.M = (function() {
  if ((!this.bvj)) {
    this.bvi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bvj = true;
  }
  return this.bvi;
});
$p.O = (function() {
  if ((!this.bvs)) {
    this.bvr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bvs = true;
  }
  return this.bvr;
});
$p.D = (function() {
  return this.bvv;
});
$p.t = (function() {
  if ((!this.bvp)) {
    this.bvo = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bvp = true;
  }
  return this.bvo;
});
$p.N = (function() {
  if ((!this.bvl)) {
    this.bvk = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bvl = true;
  }
  return this.bvk;
});
$p.Q = (function() {
  if ((!this.bvn)) {
    this.bvm = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00246.$c_Lpresto_RegisterPageView$$anon$6();
    this.bvn = true;
  }
  return this.bvm;
});
$p.v = (function() {
  if ((!this.bvu)) {
    this.bvt = false;
    this.bvu = true;
  }
  return this.bvt;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee48) => ((p) => \u03b4scrutinee48.H3(p)))($j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024.$m_Lpresto_types$MorbidUserDetails$())));
});
var $d_Lpresto_RegisterPageView$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$5, "presto.RegisterPageView$$anon$5", ({
  Qc: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$5 as $d_Lpresto_RegisterPageView$$anon$5 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$5.js.map
